import dayjs from 'dayjs';

// Used to get diff in days for Overview OTB/Market OTB/ADR/Revenue KPI out of sync behavior
export default function timestampDiffInDays(updateTimestamp: string): number {
  const extractDateTimeToUse = dayjs.utc(updateTimestamp.split('T')[0]);

  const diffInDays = dayjs.utc().diff(extractDateTimeToUse, 'days');

  return diffInDays;
}
